module.exports = __webpack_public_path__ + "static/img/3.72480e98.png";